const strip = (str: string) => str.replace(/\s+/g, '');

export default strip;
